var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{class:'row margin-bottom-7 ' + _vm.typeList},[_vm._t("options")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }